export const GET_PROGRAM_CHARTDATA_REQUEST = 'GET_PROGRAM_CHARTDATA_REQUEST';
export const GET_PROGRAM_CHARTDATA_SUCCESS = 'GET_PROGRAM_CHARTDATA_SUCCESS';
export const GET_PROGRAM_CHARTDATA_FAILED = 'GET_PROGRAM_CHARTDATA_FAILED';

export const GET_PRACTITIONER_DETAIL_CHART_REQUEST = 'GET_PRACTITIONER_DETAIL_CHART_REQUEST';
export const GET_PRACTITIONER_DETAIL_CHART_SUCCESS = 'GET_PRACTITIONER_DETAIL_CHART_SUCCESS';
export const GET_PRACTITIONER_DETAIL_CHART_FAILED = 'GET_PRACTITIONER_DETAIL_CHART_FAILED';
export const getProgramChartData = (data) => {
  return { type: GET_PROGRAM_CHARTDATA_REQUEST, payload: data };
};

export const getPractitionerDetailChart = (data) => {
  return { type: GET_PRACTITIONER_DETAIL_CHART_REQUEST, payload: data };
};
